// src/components/common/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[var(--surface)] border-t border-[var(--border)] py-8 mt-8 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="font-bold text-lg text-primary mb-4">🍱 Foodies Tiffin</h3>
            <p className="text-[var(--text-secondary)] text-sm">Fresh meals delivered daily with love ❤️</p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-[var(--text)] mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm text-[var(--text-secondary)]">
              <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/tiffin-service" className="hover:text-primary transition-colors">Meals</Link></li>
              <li><Link to="/my-orders" className="hover:text-primary transition-colors">Orders</Link></li>
              <li><Link to="/profile" className="hover:text-primary transition-colors">Profile</Link></li>
            </ul>
          </div>
          
          {/* Support - No icons */}
          <div>
            <h4 className="font-semibold text-[var(--text)] mb-3">Support</h4>
            <ul className="space-y-2 text-sm text-[var(--text-secondary)]">
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact Us</Link></li>
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><Link to="/delete-account-info" className="hover:text-primary transition-colors">Delete Account</Link></li>
            </ul>
          </div>
          
          {/* Follow Us */}
          <div>
            <h4 className="font-semibold text-[var(--text)] mb-3">Follow Us</h4>
            <div className="flex gap-4 text-xl">
              <a href="#" className="text-[var(--text-secondary)] hover:text-primary transition-colors"><FaFacebook /></a>
              <a href="#" className="text-[var(--text-secondary)] hover:text-primary transition-colors"><FaInstagram /></a>
              <a href="#" className="text-[var(--text-secondary)] hover:text-primary transition-colors"><FaTwitter /></a>
              <a href="#" className="text-[var(--text-secondary)] hover:text-primary transition-colors"><FaYoutube /></a>
            </div>
            <p className="mt-4 text-sm text-[var(--text-secondary)]">📱 Download our app</p>
          </div>
        </div>
        
        {/* Footer Bottom Links */}
        <div className="border-t border-[var(--border)] mt-6 pt-4 flex flex-wrap justify-center items-center gap-3 text-sm">
          <Link 
            to="/about" 
            className="text-[var(--text-secondary)] hover:text-primary transition-colors"
          >
            About Us
          </Link>
          
          <span className="text-[var(--text-secondary)]">|</span>
          
          <Link 
            to="/privacy" 
            className="text-[var(--text-secondary)] hover:text-primary transition-colors"
          >
            Privacy Policy
          </Link>
          
          <span className="text-[var(--text-secondary)]">|</span>
          
          <Link 
            to="/terms" 
            className="text-[var(--text-secondary)] hover:text-primary transition-colors"
          >
            Terms of Service
          </Link>
          
          <span className="text-[var(--text-secondary)]">|</span>
          
          <Link 
            to="/delete-account-info" 
            className="text-[var(--text-secondary)] hover:text-primary transition-colors"
          >
            Delete Account
          </Link>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-[var(--border)] mt-4 pt-4 text-center text-[var(--text-secondary)] text-sm">
          <p>© 2026 Foodies Tiffin Service. All rights reserved.</p>
          <p className="mt-1">Made with ❤️ for food lovers</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;